import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'csi-account-access-instructions-modal',
  templateUrl: './account-access-instructions-modal.component.html',
  styleUrls: ['./account-access-instructions-modal.component.css']
})
export class AccountAccessInstructionsModalComponent implements OnInit {
  @Input() showCloseButton = true;

  public locationOrigin = window.location.origin;

  constructor() {}

  ngOnInit() {}

  public getLocationOrigin(): string {
    return this.locationOrigin;
  }
}
